import { render, staticRenderFns } from "./impuestosInventario.vue?vue&type=template&id=4a924242"
import script from "./impuestosInventario.vue?vue&type=script&lang=js"
export * from "./impuestosInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports